import { SubmitHandler, useForm } from "react-hook-form";
import { onSubmitError } from "@talladega/helpers";
import { SubStepButtons } from "@talladega/components";
import BuyerSellerInformationFormFields, {
  focusOrder,
} from "./BuyerSellerInformationFormFields";
import {
  BuyerSellerFieldsInput,
  SellerInformationFormInput,
} from "../types/BillOfSaleFormFields";
import { CombinedFormInformation } from "../hooks/useBillOfSaleFormStepsReducer";

type Props = {
  onBack?: () => void;
  onNext: (formData: BuyerSellerFieldsInput) => void;
  formInformation: CombinedFormInformation;
  hideBackButton?: boolean;
  required?: boolean;
};

const sellerInformationFieldsKey = "sellerInformation";

const SellerStep = ({
  onBack,
  onNext,
  formInformation,
  hideBackButton = false,
  required = false,
}: Props) => {
  const sellerInformationForm = useForm<SellerInformationFormInput>({
    defaultValues: {
      sellerInformation: formInformation.sellerInformation,
    },
  });

  const {
    formState: { isSubmitting },
  } = sellerInformationForm;

  const onSubmitSellerInfo: SubmitHandler<SellerInformationFormInput> = (
    sellerInformationInput: SellerInformationFormInput
  ) => {
    const { sellerInformation } = sellerInformationInput;
    onNext(sellerInformation);
  };

  return (
    <form
      onSubmit={sellerInformationForm.handleSubmit(
        onSubmitSellerInfo,
        onSubmitError(
          focusOrder.map((field) => `${sellerInformationFieldsKey}.${field}`)
        )
      )}
    >
      <div className="mt-6 p-8 w-full border rounded-xl border-gray-200">
        <div className="flex flex-col gap-4">
          <BuyerSellerInformationFormFields
            fieldsKey={sellerInformationFieldsKey}
            formMethods={sellerInformationForm}
            required={required}
          />
        </div>
        <div className="mt-6">
          <SubStepButtons
            hideBackButton={hideBackButton}
            backButton={{ disabled: isSubmitting, onClick: onBack }}
            nextButton={{ disabled: isSubmitting }}
          />
        </div>
      </div>
    </form>
  );
};

export default SellerStep;
